export interface PrefectureEvent {
  id: number | string;
  title: string;
  date: string;
  time: string;
  venue: string;
  address: string;
  prefecture: string;
  description: string;
  price: string;
  category: string;
  thumbnail: string;
  gallery: string[];
  artistIds: number[];
  artistNames?: string[];
  isFeatured?: boolean;
  color?: string;
  attributeId?: string;
  mainGenreId?: string;
  mainPartId?: string;
  created_by?: string;
  // 有料チケット関連
  is_paid_event?: boolean;
  ticket_price?: number | null;
  max_capacity?: number | null;
  current_reservations?: number;
  sold_out?: boolean;
}

export const naraEvents: PrefectureEvent[] = [
  {
    id: 1,
    title: 'NARA UNDERGROUND vol.12',
    date: '2025-02-15',
    time: '18:00 OPEN / 18:30 START',
    venue: 'ECHO CHAMBER',
    address: '奈良市小西町8-1',
    description: '奈良アンダーグラウンドシーンを代表するアーティストが集結するライブイベント。エレクトロニカからノイズまで、ジャンルを超えた一夜。',
    category: 'LIVE',
    color: '#ff006e',
    thumbnail: 'https://public.readdy.ai/ai/img_res/1cb0e4f465271c2fa732e6e4c8193258.jpg',
    gallery: [
      'https://readdy.ai/api/search-image?query=A%20dramatic%20concert%20flyer%20design%20with%20bold%20typography%20neon%20pink%20accents%20on%20dark%20background%20featuring%20abstract%20geometric%20shapes%20and%20glitch%20art%20effects%20underground%20music%20event%20promotional%20poster%20style&width=600&height=800&seq=evt1flyer1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Live%20music%20performance%20in%20a%20dark%20intimate%20venue%20with%20pink%20and%20magenta%20stage%20lights%20musician%20playing%20electric%20guitar%20on%20stage%20smoke%20effects%20dramatic%20concert%20photography%20underground%20scene&width=800&height=500&seq=evt1gal1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Crowd%20at%20an%20underground%20electronic%20music%20event%20hands%20raised%20neon%20pink%20and%20cyan%20lighting%20atmospheric%20fog%20machine%20effects%20dark%20venue%20concert%20photography%20from%20behind%20the%20audience&width=800&height=500&seq=evt1gal2&orientation=landscape',
    ],
    artistIds: [10, 11],
    artistNames: ['NEON DRIFT'],
    price: '¥2,500 + 1D',
    isFeatured: true,
    attributeId: undefined,
    mainGenreId: undefined,
    mainPartId: undefined,
  },
  {
    id: 2,
    title: 'Ambient Night Session',
    date: '2025-02-22',
    time: '20:00 OPEN / 20:30 START',
    venue: 'NOISE CAFE LIVE',
    address: '奈良市餅飯殿町12',
    description: 'アンビエント・ドローンミュージックに特化した静謐な夜。キャンドルライトの中で音の波に身を委ねる特別な体験。',
    category: 'LIVE',
    color: '#00d9ff',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20serene%20ambient%20music%20performance%20in%20a%20dimly%20lit%20cafe%20with%20candles%20soft%20cyan%20blue%20lighting%20musician%20playing%20synthesizer%20atmospheric%20dreamy%20mood%20intimate%20small%20venue%20audience%20sitting%20quietly%20immersive%20sound%20experience&width=520&height=320&seq=event2a&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Minimalist%20ambient%20music%20event%20flyer%20with%20soft%20cyan%20blue%20gradient%20background%20delicate%20typography%20floating%20particles%20ethereal%20dreamy%20design%20style%20promotional%20poster%20for%20a%20calm%20music%20night&width=600&height=800&seq=evt2flyer1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Ambient%20musician%20performing%20with%20modular%20synthesizer%20in%20a%20candlelit%20room%20soft%20blue%20and%20warm%20lighting%20cables%20and%20knobs%20visible%20intimate%20performance%20setting%20atmospheric%20photography&width=800&height=500&seq=evt2gal1&orientation=landscape',
    ],
    artistIds: [9],
    artistNames: ['MUON'],
    price: '¥2,000 + 1D',
    isFeatured: false,
    attributeId: undefined,
    mainGenreId: undefined,
    mainPartId: undefined,
  },
  {
    id: 3,
    title: 'BEAT MAKERS WORKSHOP',
    date: '2025-03-01',
    time: '14:00 - 18:00',
    venue: 'DRIFT STUDIO',
    address: '橿原市久米町564',
    description: 'ビートメイキングの基礎から応用まで学べるワークショップ。DAWの使い方からミキシングまで、プロが直接指導。初心者歓迎。',
    category: 'WORKSHOP',
    color: '#00ff41',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20music%20production%20workshop%20in%20a%20professional%20studio%20setting%20with%20participants%20learning%20beat%20making%20on%20laptops%20and%20MIDI%20controllers%20green%20ambient%20LED%20lighting%20instructor%20demonstrating%20on%20mixing%20console%20educational%20creative%20atmosphere&width=520&height=320&seq=event3a&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Music%20production%20workshop%20flyer%20with%20green%20neon%20accents%20on%20dark%20background%20featuring%20MIDI%20controller%20illustration%20waveform%20graphics%20bold%20modern%20typography%20educational%20event%20promotional%20design&width=600&height=800&seq=evt3flyer1&orientation=portrait',
    ],
    artistIds: [],
    artistNames: [],
    price: '¥3,500',
    isFeatured: false,
    attributeId: undefined,
    mainGenreId: undefined,
    mainPartId: undefined,
  },
  {
    id: 4,
    title: 'MIDNIGHT RAVE 003',
    date: '2025-03-08',
    time: '23:00 - 05:00',
    venue: 'MIDNIGHT CLUB',
    address: '奈良市角振町26',
    description: 'テクノ・ハウスを中心としたオールナイトレイヴ。国内外のDJが出演する奈良最大級のクラブイベント。',
    category: 'DJ EVENT',
    color: '#b537f2',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20high%20energy%20rave%20party%20in%20a%20dark%20nightclub%20with%20purple%20and%20magenta%20laser%20beams%20cutting%20through%20dense%20fog%20DJ%20performing%20on%20elevated%20booth%20crowd%20dancing%20with%20hands%20up%20strobe%20lights%20and%20LED%20panels%20creating%20immersive%20visual%20experience&width=520&height=320&seq=event4a&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Rave%20party%20event%20flyer%20with%20vibrant%20purple%20and%20magenta%20colors%20abstract%20geometric%20patterns%20laser%20beam%20effects%20bold%20futuristic%20typography%20dark%20background%20nightclub%20DJ%20event%20promotional%20poster%20design&width=600&height=800&seq=evt4flyer1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=DJ%20performing%20at%20a%20nightclub%20booth%20with%20purple%20laser%20lights%20and%20LED%20screens%20behind%20mixing%20turntables%20and%20CDJs%20crowd%20visible%20in%20foreground%20energetic%20rave%20atmosphere%20photography&width=800&height=500&seq=evt4gal1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Nightclub%20dance%20floor%20from%20above%20with%20purple%20and%20pink%20lighting%20crowd%20dancing%20together%20strobe%20lights%20and%20fog%20machine%20effects%20energetic%20rave%20party%20atmosphere%20aerial%20view%20photography&width=800&height=500&seq=evt4gal2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20DJ%20hands%20on%20mixing%20console%20with%20purple%20ambient%20lighting%20vinyl%20records%20and%20headphones%20visible%20professional%20DJ%20equipment%20nightclub%20setting%20atmospheric%20photography&width=800&height=500&seq=evt4gal3&orientation=landscape',
    ],
    artistIds: [19, 15],
    artistNames: ['NEURAL WAVE'],
    price: '¥3,000 + 1D',
    isFeatured: true,
    attributeId: undefined,
    mainGenreId: undefined,
    mainPartId: undefined,
  },
  {
    id: 5,
    title: 'PEDAL CRAFT FAIR',
    date: '2025-03-15',
    time: '11:00 - 17:00',
    venue: 'GRIND WORKSHOP',
    address: '生駒市東生駒1-70',
    description: 'ハンドメイドエフェクターの展示即売会。自作エフェクターのデモ試奏や、パーツ販売も。ギタリスト必見のイベント。',
    category: 'MARKET',
    color: '#ff8c00',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20craft%20fair%20for%20handmade%20guitar%20effects%20pedals%20displayed%20on%20wooden%20tables%20with%20warm%20amber%20lighting%20visitors%20testing%20pedals%20with%20guitars%20electronic%20components%20and%20soldering%20stations%20creative%20maker%20market%20atmosphere&width=520&height=320&seq=event5a&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Craft%20market%20event%20flyer%20with%20warm%20orange%20and%20amber%20tones%20featuring%20hand%20drawn%20illustrations%20of%20guitar%20pedals%20and%20electronic%20components%20vintage%20style%20typography%20maker%20fair%20promotional%20poster%20design&width=600&height=800&seq=evt5flyer1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Handmade%20guitar%20effect%20pedals%20displayed%20on%20a%20wooden%20table%20at%20a%20craft%20fair%20warm%20amber%20lighting%20colorful%20custom%20painted%20enclosures%20knobs%20and%20switches%20visible%20artisan%20electronics%20market%20photography&width=800&height=500&seq=evt5gal1&orientation=landscape',
    ],
    artistIds: [],
    artistNames: [],
    price: '入場無料',
    isFeatured: false,
    attributeId: undefined,
    mainGenreId: undefined,
    mainPartId: undefined,
  },
  {
    id: 6,
    title: 'SOUND ART EXHIBITION',
    date: '2025-03-22',
    time: '10:00 - 19:00',
    venue: 'WARP GALLERY',
    address: '天理市川原城町680',
    description: '音と空間をテーマにしたサウンドアート展。インタラクティブなインスタレーション作品を体験できる2週間限定の展覧会。',
    category: 'EXHIBITION',
    color: '#ffd600',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20contemporary%20sound%20art%20exhibition%20in%20a%20minimalist%20white%20gallery%20space%20with%20interactive%20audio%20installations%20speakers%20hanging%20from%20ceiling%20visitors%20experiencing%20immersive%20sound%20pieces%20warm%20yellow%20accent%20lighting%20modern%20art%20museum%20atmosphere&width=520&height=320&seq=event6a&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Art%20exhibition%20poster%20with%20warm%20yellow%20and%20gold%20accents%20on%20white%20background%20minimalist%20typography%20abstract%20sound%20wave%20illustrations%20contemporary%20gallery%20event%20promotional%20design%20clean%20modern%20layout&width=600&height=800&seq=evt6flyer1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Interactive%20sound%20art%20installation%20in%20a%20white%20gallery%20space%20with%20hanging%20speakers%20and%20wires%20visitor%20touching%20a%20sensor%20panel%20warm%20yellow%20spotlights%20contemporary%20art%20exhibition%20photography&width=800&height=500&seq=evt6gal1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Modern%20art%20gallery%20interior%20with%20sound%20installations%20on%20pedestals%20visitors%20wearing%20headphones%20experiencing%20audio%20art%20pieces%20warm%20yellow%20ambient%20lighting%20minimalist%20white%20walls%20exhibition%20photography&width=800&height=500&seq=evt6gal2&orientation=landscape',
    ],
    artistIds: [16],
    artistNames: [],
    price: '¥1,000',
    isFeatured: false,
    attributeId: undefined,
    mainGenreId: undefined,
    mainPartId: undefined,
  },
];
